import { API_ERROR_MESSAGE } from '../../utils/Constants'
import { downloadImage } from '../../utils/utils'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds, ReportTypes } from '../apiConstants'
import { makeApiCall } from '../APIService'
import { getFilenameFromHeader } from '../../utils/get-filename-header'

export type DownloadFileResult = {
  filename: string
  blob: Blob
}

interface FaceViewProps {
  body: Record<string, any>
}
export const LoadReport = async (props: FaceViewProps) => {
  const { body } = props
  const headers: Record<string, string> = {
    Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    'Content-Type': 'application/json',
  }
  const url = `${getAPIUrl()}/FaceView/load-report`
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
  if (!res.ok) {
    return null
  }
  const data = await res.json()
  console.log(data, 'data inside api call')
  return data
}
export const DownloadFaceViewReport = async (
  props: FaceViewProps,
): Promise<DownloadFileResult | null> => {
  const { body } = props
  const headers: Record<string, string> = {
    Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    'Content-Type': 'application/json',
  }
  const url = `${getAPIUrl()}/FaceView/download-report`
  const res = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
  if (!res.ok) {
    return null
  }
  const filename = getFilenameFromHeader(res.headers.get('Content-Disposition'))
  const blob = await res.blob()
  return {
    filename,
    blob,
  }
}
